import { useIntl } from '@capsicum/common';

import type { SignTypedDataProps } from '../models';

export const useSignTypedData = ({
	domain,
	message,
	origin,
	primaryType
}: Pick<SignTypedDataProps, 'domain' | 'message' | 'origin' | 'primaryType'>) => {
	const { $t } = useIntl();

	const formatDomain = () => {
		const parts: Array<string> = [];

		if (domain.name) parts.push(domain.name);
		if (domain.version) parts.push(`v${domain.version}`);

		return parts.join(' ');
	};

	const formatMessage = () => {
		return Object.entries(message)
			.map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
			.join('\n');
	};

	// Translation keys
	const translations = {
		domainTitle: $t('ncWallet.walletConnect.signingModal.domainTitle'),
		messageTitle: $t('ncWallet.walletConnect.signingModal.messageTitle'),
		primaryTypeTitle: $t('ncWallet.walletConnect.signingModal.primaryTypeTitle'),
		smartContractTitle: $t('ncWallet.walletConnect.signingModal.smartContractTitle'),
		title: $t('ncWallet.walletConnect.signingModal.title')
	};

	// Test IDs
	const testIds = {
		contract: 'wallet-connect-modal-signing-contract',
		domain: 'wallet-connect-modal-signing-domain',
		message: 'wallet-connect-modal-signing-message',
		primaryType: 'wallet-connect-modal-signing-primary-type'
	};

	return {
		domain,
		formatDomain,
		formatMessage,
		message,
		origin,
		primaryType,
		testIds,
		translations
	};
};
